<template>
    <div class="small-6 medium-4 large-12 cell">
        <a v-if="value.href != '#'" :class="'button ' + value.class " :href="value.href">{{ value.text }}</a>
        <button v-else :class="'button ' + value.class " :href="value.href" @click="btnclicked($event, value.function)">{{ value.text }}</button>
    </div>
</template>
<script setup>
    const props = defineProps([ 'value' ])
    const emit = defineEmits([ 'do-action' ])

    function btnclicked(event, fn) {
        if (fn != '') {
            emit('do-action', fn);
        }
    }
</script>